import React from 'react'
import { Chip, makeStyles } from '@material-ui/core'
import {
    CheckCircle as CheckCircleIcon,
    Warning as WarningIcon,
    Schedule as ScheduleIcon,
    Block as BlockIcon,
    Send as SendIcon,
    Drafts as DraftsIcon,
} from '@material-ui/icons'

const useStyles = makeStyles(() => ({
    statusChip: {
        fontWeight: 500,
        minWidth: 100,
        '& .MuiIcon-root': {
            color: 'inherit',
        },
        '& .MuiSvgIcon-root': {
            color: 'inherit',
        },
    },
    statusIcon: {
        width: 16,
        height: 16,
        color: 'inherit',
    },
}))

interface StatusBadgeProps {
    status: string
    voided?: boolean
    reviewed?: boolean
}

export const InvoiceStatusBadge: React.FC<StatusBadgeProps> = ({
    status,
    reviewed,
    voided = false,
}) => {
    const classes = useStyles()

    const getStatusConfig = (status: string, voided: boolean) => {
        if (voided) {
            return {
                label: 'Voided',
                style: { backgroundColor: '#444', color: 'white' },
                icon: (
                    <BlockIcon className={classes.statusIcon} color="inherit" />
                ),
            }
        }

        switch (status.toLowerCase()) {
            case 'draft':
                if (reviewed) {
                    return {
                        label: 'Ready to Send',
                        style: {
                            backgroundColor: 'rgba(25, 164, 126, 1)',
                            color: 'white',
                        },
                        icon: <DraftsIcon className={classes.statusIcon} />,
                    }
                } else {
                    return {
                        label: 'Review',
                        style: {
                            backgroundColor: 'rgba(206, 26, 6, 1)',
                            color: 'white',
                        },
                        icon: <DraftsIcon className={classes.statusIcon} />,
                    }
                }
            case 'sent':
                return {
                    label: 'Sent',
                    style: { backgroundColor: '#2196f3', color: 'white' },
                    icon: <SendIcon className={classes.statusIcon} />,
                }
            case 'paid':
                return {
                    label: 'Paid',
                    style: { backgroundColor: '#4caf50', color: 'white' },
                    icon: (
                        <CheckCircleIcon
                            className={classes.statusIcon}
                            color="inherit"
                        />
                    ),
                }
            case 'overdue':
                return {
                    label: 'Overdue',
                    style: { backgroundColor: '#f44336', color: 'white' },
                    icon: (
                        <WarningIcon
                            className={classes.statusIcon}
                            color="inherit"
                        />
                    ),
                }
            case 'pending':
                return {
                    label: 'Pending',
                    style: { backgroundColor: '#ff9800', color: 'white' },
                    icon: (
                        <ScheduleIcon
                            className={classes.statusIcon}
                            color="inherit"
                        />
                    ),
                }
            default:
                return {
                    label: status,
                    style: { backgroundColor: '#9e9e9e', color: 'white' },
                    icon: undefined,
                }
        }
    }

    const config = getStatusConfig(status, voided)

    return (
        <Chip
            icon={config.icon}
            label={config.label}
            style={config.style}
            size="small"
            className={classes.statusChip}
        />
    )
}
